export const STORAGE_KEYS = Object.freeze({
  USER: 'VNJ_USER',
  SESSION: 'VNJ_SESSION',
  AGENT_CODE: 'VNJ_AGENT_CODE',
  AGENT_DOMAIN: 'VNJ_AGENT_DOMAIN',
  PRICE_TERMS: 'VNJ_PRICE_TERMS',
});
